/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'customer-service': {
    width: 54,
    height: 54,
    viewBox: '0 0 54 54',
    data: '<defs/><path pid="0" class="a" d="M48.6 0A5.536 5.536 0 0 1 54 5.4v32.4a5.536 5.536 0 0 1-5.4 5.4H10.8L0 54V5.4A5.536 5.536 0 0 1 5.4 0zM18.9 24.3v-5.4h-5.4v5.4zm10.8 0v-5.4h-5.4v5.4zm10.8 0v-5.4h-5.4v5.4z"/>'
  }
})
